import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { changeDateFormat, changeNumberFormat } from '@/assets/common/services'
import ChemicalSelectModal from '@/components/Warehouses/ChemicalSelectModal/ChemicalSelectModal.vue';
import FertilizerSelectModal from '@/assets/common/Modal/ItemSelectModal/FertilizerSelectModal/FertilizerSelectModal.vue';
import MaterialSelectModal from '@/assets/common/Modal/ItemSelectModal/MaterialSelectModal/MaterialSelectModal.vue'
import PurchaseHistoryModal from '../PurchaseHistoryModal/PurchaseHistoryModal.vue';
import ChemicalBulkInsertModal from '../ChemicalBulkInsertModal/ChemicalBulkInsertModal.vue';
import DepriciationMaterialAddModal from '@/components/Warehouses/DepreciationMaterialAddModal/DepreciationMaterialAddModal.vue'
import { SelectedChemical } from '@/components/Warehouses/ChemicalSelectModal/ChemicalSelectModal';
import { WarehouseChemicalPostModel, WarehouseDepreciationMaterialPostModel, WarehouseDetailResponse, WarehouseExpendableMaterialPostModel, WarehouseFertilizerPostModel, WarehousePostModel } from '@/types/APIResponse';
import { DepreicationAdd, WarehouseChemical, WarehouseDepreciationMaterial, WarehouseDetailType, WarehouseExpendableMaterial, WarehouseFertilizer } from '@/types/Component';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';

type Fertilizer = {
    id: string;
    name: string;
    disabledCheck: boolean;
    tenantId : string;
}

type Material = {
    id: string;
    name: string;
    disabledCheck: boolean;
}

@Component({
    components: {
        ChemicalSelectModal,
        FertilizerSelectModal,
        MaterialSelectModal,
        PurchaseHistoryModal,
        DepriciationMaterialAddModal,
        ChemicalBulkInsertModal
    },
    filters: {
        changeDateFormat,
        changeNumberFormat
    }
})
export default class Warehouses extends Vue {
    warehouseDetail: WarehouseDetailType = {
        id: '',
        name: '',
        memo: '',
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false,
        updated : null
    }

    selectedWareHouseDetail: WarehouseDetailType = {
        id: '',
        name: '',
        memo: '',
        chemicals: [],
        fertilizers: [],
        depreciationMaterials: [],
        expendableMaterials: [],
        isHidden: false,
        updated: null
    }

    private baseUrl = '/admin/warehouses'


    // 農薬選択モーダルProps
    private showChemicalSelectModal = false
    private initializeChemicals: SelectedChemical[] = []

    // 肥料選択モーダルProps
    private showFertilizerSelectModal = false
    private initializeFertilizers: Fertilizer[] = []

    // 資材選択モーダル
    private showMaterialSelectModal = false
    private initializeMaterials: Material[] = []

    // 減価償却選択モーダルProps
    private showDepreciationMaterialAddModal = false

    // 購入履歴モーダル
    private showPurchaseHistoryModal = false

    //一括登録モーダル
    private showChemicalBulkInsertModal = false

    // 単位変更モーダルProps
    private showUnitChangeConfirmPopup = false
    private showUnitChangeConfirmPopupIndex : number | null = null;
    private chemicalOrFertilizer : string | null = null;
    private msgForNotUsed = false;
    @Prop()
    private selectedWarehouseId!: string

    private itemType: 'chemicals' | 'fertilizers' = 'chemicals'
    private itemId = ''
    private unitName = ''
    private itemName = ''

    private deleteChemicals: WarehouseChemical[] = []
    private deleteFertilizers: WarehouseFertilizer[] = []
    private deleteExpendableMaterials: WarehouseExpendableMaterial[] = []
    private deleteDepreciationMaterials: WarehouseDepreciationMaterial[] = []
    private chemicalUnits = [] as any[];
    private fertilizerUnits = [] as any[];

    purchaseHistoryChange = false;

    private selectedTab: 'chemicalOrFertilizer' | 'depreciation' | 'expendable' = 'chemicalOrFertilizer'

    get headerTitle(): string {
        return this.selectedWarehouseId === 'create' ? '新規倉庫' : '倉庫情報'
    }

    @Watch('selectedWarehouseId', { immediate: true })
    async changeWarehouseId(): Promise<void> {
        this.deleteChemicals = []
        this.deleteFertilizers = []
        this.deleteExpendableMaterials = []
        if (this.selectedWarehouseId && this.selectedWarehouseId !== 'create') {
            await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.selectedWarehouseId}`).then((res: WarehouseDetailResponse) => {
                this.warehouseDetail = toCamel(res) as WarehouseDetailType
                this.selectedWareHouseDetail = toCamel(res) as WarehouseDetailType
                for (const chemical of this.warehouseDetail.chemicals) {
                    chemical.previousUnit = chemical.unitName;
                    chemical.actualUnit = chemical.unitName;
                }
                for (const fertilizer of this.warehouseDetail.fertilizers) {
                    fertilizer.previousUnit = fertilizer.unitName;
                    fertilizer.actualUnit = fertilizer.unitName;
                }
            })
        }
        else {
            this.warehouseDetail = {
                id: '',
                name: '',
                memo: '',
                chemicals: [],
                fertilizers: [],
                depreciationMaterials: [],
                expendableMaterials: [],
                isHidden: false,
                updated : null
            }
        }
        this.getChemicalUnits();
        this.getFertilizerUnits();
    }

    getChemicalUnits() {
        this.$apiClient.doRequest('get','/unit_conversion/chemicals').then((res) => {
        this.chemicalUnits = res.weight_units
        })
    }

    getFertilizerUnits() {
        this.$apiClient.doRequest('get','/unit_conversion/fertilizer').then((res) => {
        this.fertilizerUnits = res.weight_units
        })
    }

    disabledChemicalCheck(chemical: WarehouseChemical): boolean {
        return !chemical.isEditable && chemical.updateType !== 'ADD'
    }

    async deleteChemical(index: number): Promise<void> {
        const chemical = this.warehouseDetail.chemicals[index];
        const type = "chemical";

        if (
            chemical.updateType !== "ADD" &&
            chemical.isEditable &&
            this.selectedWarehouseId !== "create" &&
            chemical.id != null
        ) {
            const url = `${this.baseUrl}/check_warehouse_item_editable/${type}/${this.selectedWarehouseId}/${chemical.id}`;
            chemical.isEditable = await this.$apiClient.doRequest("get", url);
            if (!chemical.isEditable) {
                window.alert("この農薬を使用した作業記録が存在しますので、削除できません。");
                return;
            }
        }

        let confirmDelete = true;
        if (chemical.updateType !== "ADD") {
            confirmDelete = window.confirm(
                "購入履歴が存在します。こちらも削除されますがよろしいですか？"
            );
        }

        if (chemical && confirmDelete) {
            if (chemical.updateType !== "ADD") {
                this.deleteChemicals.push({
                    ...chemical,
                    updateType: "DELETE",
                });
            }
            this.warehouseDetail.chemicals.splice(index, 1);
            this.inputChanged();
        }
    }

    async openUnitConfirmationModal(index: number, kind: string): Promise<void> {
        const item = kind === 'chemical' ? this.warehouseDetail.chemicals[index] : this.warehouseDetail.fertilizers[index];
        if (item.updateType !== 'ADD' && item.unitName !== item.actualUnit) {
            if (item.isEditable && this.selectedWarehouseId != 'create' && item.id != null) {
                const url = `${this.baseUrl}/check_warehouse_item_editable/${kind}/${this.selectedWarehouseId}/${item.id}`;
                item.isEditable = await this.$apiClient.doRequest('get', url);
            }
            this.showUnitChangeConfirmPopupIndex = index;
            this.chemicalOrFertilizer = kind;
            this.showUnitChangeConfirmPopup = true;
            this.msgForNotUsed = item.isEditable;
        } else {
            this.inputChanged();
        }
        this.inputChanged();
    }

    updateUnit(index: number, kind: string, action: boolean | undefined): void {
        if (kind === 'chemical') {
            const chemical = this.warehouseDetail.chemicals[index]
            if (action === true) {//yes
                this.warehouseDetail.chemicals[index] = {
                    ...chemical,
                    updateType: 'UPDATE',
                    isUnitChanged: true,
                    previousUnit: chemical.unitName,
                    isUnitConversionNeeded: true
                }
                this.inputChanged();
            } else if (action === false) {//no
                this.warehouseDetail.chemicals[index] = {
                    ...chemical,
                    updateType: 'UPDATE',
                    isUnitChanged: false,
                    previousUnit: chemical.unitName,
                    isUnitConversionNeeded: false
                }
                this.inputChanged();
            } else {//cancel
                this.warehouseDetail.chemicals[index] = {
                    ...chemical,
                    updateType: 'UPDATE',
                    unitName: chemical.previousUnit,
                }
            }
        } else {
            const fertilizer = this.warehouseDetail.fertilizers[index]
            if (action === true) {//yes
                this.warehouseDetail.fertilizers[index] = {
                    ...fertilizer,
                    updateType: 'UPDATE',
                    isUnitChanged: true,
                    previousUnit: fertilizer.unitName,
                    isUnitConversionNeeded: true
                }
                this.inputChanged();
            } else if (action === false) {//no
                this.warehouseDetail.fertilizers[index] = {
                    ...fertilizer,
                    updateType: 'UPDATE',
                    isUnitChanged: false,
                    previousUnit: fertilizer.unitName,
                    isUnitConversionNeeded: false
                }
                this.inputChanged();
            } else {//cancel
                this.warehouseDetail.fertilizers[index] = {
                    ...fertilizer,
                    updateType: 'UPDATE',
                    unitName: fertilizer.previousUnit,
                }
            }
        }
        this.showUnitChangeConfirmPopup = false
        this.showUnitChangeConfirmPopupIndex = null
        this.chemicalOrFertilizer = null
        this.msgForNotUsed = false
    }

    disabledFertilizerCheck(fertilizer: WarehouseFertilizer): boolean {
        return !fertilizer.isEditable && fertilizer.updateType !== 'ADD'
    }

    async deleteFertilizer(index: number): Promise<void> {
        const fertilizer = this.warehouseDetail.fertilizers[index];
        const type = "fertilizer";

        if (
            fertilizer.updateType !== "ADD" &&
            fertilizer.isEditable &&
            this.selectedWarehouseId !== "create" &&
            fertilizer.id != null
        ) {
            const url = `${this.baseUrl}/check_warehouse_item_editable/${type}/${this.selectedWarehouseId}/${fertilizer.id}`;
            fertilizer.isEditable = await this.$apiClient.doRequest("get", url);
            if (!fertilizer.isEditable) {
                window.alert("この肥料を使用した作業記録が存在しますので、削除できません。");
                return;
            }
        }

        let confirmDelete = true;
        if (fertilizer.updateType !== "ADD") {
            confirmDelete = window.confirm(
                "購入履歴が存在します。こちらも削除されますがよろしいですか？"
            );
        }

        if (confirmDelete) {
            if (fertilizer.updateType !== "ADD") {
                this.deleteFertilizers.push({
                    ...fertilizer,
                    updateType: "DELETE",
                });
            }
            this.warehouseDetail.fertilizers.splice(index, 1);
            this.inputChanged();
        }
    }

    disabledExpendableMaterialCheck(material: WarehouseExpendableMaterial): boolean {
        return !material.isEditable && material.updateType !== 'ADD'
    }

    async deleteExpendableMaterial(index: number): Promise<void> {
        const material = this.warehouseDetail.expendableMaterials[index];
        const type = "expendable";
        if (
            material.updateType !== "ADD" &&
            material.isEditable &&
            this.selectedWarehouseId !== "create" &&
            material.id != null
        ) {
            const url = `${this.baseUrl}/check_warehouse_item_editable/${type}/${this.selectedWarehouseId}/${material.id}`;
            material.isEditable = await this.$apiClient.doRequest("get", url);
    
            if (!material.isEditable) {
                window.alert("この消耗品を使用した作業記録が存在しますので、削除できません。");
                return;
            }
        }
        let confirmDelete = true;
        if (material.updateType !== "ADD") {
            confirmDelete = window.confirm(
                "購入履歴が存在します。こちらも削除されますがよろしいですか？"
            );
        }
        if (confirmDelete) {
            if (material.updateType !== "ADD") {
                this.deleteExpendableMaterials.push({
                    ...material,
                    updateType: "DELETE",
                });
            }
            this.warehouseDetail.expendableMaterials.splice(index, 1);
            this.inputChanged();
        }
    }

    updateExpendableMaterial(index: number): void {
        const material = this.warehouseDetail.expendableMaterials[index]
        if (material.updateType !== 'ADD') {

            this.deleteExpendableMaterials[index] = {
                ...material,
                updateType: 'UPDATE'
            }

        }
    }

    disabledDepreciationMaterialCheck(material: WarehouseDepreciationMaterial): boolean {
        return !material.isEditable && material.updateType != 'ADD'
    }

    async deleteDepreciationMaterial(index: number): Promise<void> {
        const material = this.warehouseDetail.depreciationMaterials[index];
        const type = "depreciation";
    
        if (
            material.updateType !== "ADD" &&
            material.isEditable &&
            this.selectedWarehouseId !== "create" &&
            material.materialId != null
        ) {
            const url = `${this.baseUrl}/check_warehouse_item_editable/${type}/${this.selectedWarehouseId}/${material.warehouseDepreciationMaterialId}`;
            material.isEditable = await this.$apiClient.doRequest("get", url);
    
            if (!material.isEditable) {
                window.alert("この減価償却を使用した作業記録が存在しますので、削除できません。");
                return;
            }
        }
    
        let confirmDelete = true;
        if (material.updateType !== "ADD") {
            confirmDelete = window.confirm(
                "購入履歴が存在します。こちらも削除されますがよろしいですか？"
            );
        }
        if (confirmDelete) {
            if (material.updateType !== "ADD") {
                this.deleteDepreciationMaterials.push({
                    ...material,
                    updateType: "DELETE",
                });
            }
            this.warehouseDetail.depreciationMaterials.splice(index, 1);
    
            this.inputChanged();
        }
    }    

    cancelEdit () {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.changeWarehouseId()
    }

    submit(): void {
        const errmsg: string[] = []
        // 名前の入力
        if (!this.warehouseDetail.name.trim()) {
            errmsg.push("倉庫名を入力してください")
        }
        // 名前の長さ
        if (this.warehouseDetail.name.length > 100) {
            errmsg.push(`倉庫名は100文字以内で入力してください（現在は${this.warehouseDetail.name.length}文字）`)
        }
        // メモ
        if (this.warehouseDetail.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.warehouseDetail.memo.length}文字）`)
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return
        }

        const chemicals: WarehouseChemicalPostModel[] = this.warehouseDetail.chemicals
            .concat(this.deleteChemicals)
            .filter(chemical => chemical.updateType)
            .map(chemical => ({
                id: chemical.id,
                name: chemical.displayName,
                unit_name: chemical.unitName,
                update_type: chemical.updateType,
                is_unit_conversion_needed: chemical.isUnitConversionNeeded || false,
                updated : null
            }))

        const fertilizers: WarehouseFertilizerPostModel[] = this.warehouseDetail.fertilizers
            .concat(this.deleteFertilizers)
            .filter(fertilizer => fertilizer.updateType)
            .map(fertilizer => ({
                id: fertilizer.id,
                name: fertilizer.name,
                unit_name: fertilizer.unitName,
                update_type: fertilizer.updateType,
                is_unit_conversion_needed: fertilizer.isUnitConversionNeeded || false,
                updated : null
            }))

        const depreciationMaterials: WarehouseDepreciationMaterialPostModel[] = this.warehouseDetail.depreciationMaterials
            .concat(this.deleteDepreciationMaterials)    
            .filter(material => material.updateType)
            .map(material => ({
                material_id: material.materialId,
                display_name: material.displayName,
                purchase_date: material.purchaseDate,
                purchase_amount: material.purchaseAmount,
                depreciation_period: material.depreciationPeriod,
                depreciation_times: material.depreciationTimes,
                update_type: material.updateType,
                warehouse_depreciation_material_id : material.warehouseDepreciationMaterialId
            }))

        const expendableMaterials: WarehouseExpendableMaterialPostModel[] = this.warehouseDetail.expendableMaterials
            .concat(this.deleteExpendableMaterials)
            .filter(material => material.updateType)
            .map(material => ({
                id: material.id,
                update_type: material.updateType,
                updated: null
            }))

        const params: WarehousePostModel = {
            name: this.warehouseDetail.name,
            memo: this.warehouseDetail.memo,
            chemicals: chemicals,
            fertilizers: fertilizers,
            depreciation_materials: depreciationMaterials,
            expendable_materials: expendableMaterials,
            updated: this.warehouseDetail.updated
        }

        // 新規登録
        if (this.selectedWarehouseId === 'create') {
            this.$apiClient.doRequest('post', `${this.baseUrl}`, params)
                .then((res) => {
                    this.$router.push(`/master/warehouses/${res.id}`, () => { return })
                    this.$toasted.success('保存しました。')
                })
                .catch(() => {
                    this.$toasted.error('保存に失敗しました。')
                })
                .finally(() => {
                    this.$emit('submitDetail')
                })
        }
        // 更新
        else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if (!result) {
                return
            }
            this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedWarehouseId}`, params)
                .then(() => {
                    this.$toasted.success('変更を保存しました。')
                    this.changeWarehouseId()
                })
                .catch(() => {
                    this.$toasted.error('変更に失敗しました。')
                })
                .finally(() => {
                    this.$emit('submitDetail')
                })
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);

    }

    // 引数は変更先の非表示設定（true: 非表示, false: 表示）
    switchDisplay(isHidden: boolean): void {
        const result = window.confirm(`${this.selectedWareHouseDetail.name}を${isHidden ? '非表示にします' : '表示状態に戻します'}。よろしいですか？`)
        if (!result) {
            return
        }
        this.$store.dispatch('doUpdateIsHiddenSwitched', true);
        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedWarehouseId}/display?is_hidden=${isHidden}`)
            .then(() => {
                this.warehouseDetail.isHidden=isHidden;
                    this.$router.push(`/master/warehouses/${this.selectedWarehouseId}`, () => { return });
            this.$store.dispatch('doUpdateIsHiddenSwitched', false);
            this.$toasted.success(isHidden  ? '非表示に変更しました。' : '表示に変更しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.$emit('submitDetail')
            })
    }

    // 農薬選択モーダル関連
    openChemicalSelectModal(): void {
        // 農薬マスタ側に単位を持っていないため、idとnameで受け渡しを行う
        this.initializeChemicals = this.warehouseDetail.chemicals.map(c => {
            return {
                id: c.id,
                name: c.displayName,
                disabledCheck: this.disabledChemicalCheck(c)
            }
        })
        this.showChemicalSelectModal = true
        this.inputChanged()
    }

    commitChemical(chemicals: SelectedChemical[]): void {
        const concatChemicals = chemicals.concat(this.warehouseDetail.chemicals.map(c => ({ id: c.id, name: c.displayName, canCheck: false })))
        const preChemicals = concatChemicals.filter((c, index, arr) => (
            arr.findIndex(next => c.id === next.id) === index
        ))
        const allChemicals = preChemicals.map(c => {
            // 既に選択済みの農薬は単位をそのままにする
            const baseItem = this.warehouseDetail.chemicals.find(item => item.id == c.id)
            const newItem = chemicals.find(item => item.id == c.id)
            const chemical = {
                id: c.id,
                displayName: c.name,
                unitName: baseItem ? baseItem.unitName : 'kg',
                isEditable: baseItem ? baseItem.isEditable : false,
                isUnitChanged: baseItem ? baseItem.isUnitChanged : false,
                previousUnit: baseItem ? baseItem.unitName : 'kg',
                actualUnit: baseItem ? baseItem.unitName : 'kg',
                isUnitConversionNeeded: baseItem ? baseItem.isUnitChanged : false,
                updateType: baseItem ? (newItem ? baseItem.updateType : 'DELETE') : 'ADD',
                updated: baseItem ? baseItem.updated:null
            }
            return chemical
        })
        this.$set(this.warehouseDetail, 'chemicals', allChemicals.filter(ac => ac.updateType !== 'DELETE'))
        this.deleteChemicals = this.deleteChemicals.concat(allChemicals.filter(ac => ac.updateType === 'DELETE'))
        this.showChemicalSelectModal = false
    }

    cancelChemicalSelect(): void {
        this.showChemicalSelectModal = false
    }

    // 肥料選択モーダル関連
    openFertilizerSelectModal(): void {
        this.initializeFertilizers = this.warehouseDetail.fertilizers.map(f => {
            return {
                id: f.id,
                name: f.name,
                disabledCheck: this.disabledFertilizerCheck(f),
                tenantId: ''
            }
        })
        this.showFertilizerSelectModal = true
        this.inputChanged()
    }

    commitFertilizer(fertilizers: Fertilizer[]): void {
        const filteredExistingFertilizers = this.warehouseDetail.fertilizers.filter(f => f.tenantId !== this.$store.getters.tenantId && f.tenantId !== undefined);
        const concatFertilizers = fertilizers.concat(this.warehouseDetail.fertilizers.map(f => ({ id: f.id, name: f.name, disabledCheck: false, tenantId: f.tenantId })))
        const preFertilizers = concatFertilizers.filter((f, index, arr) => (
            arr.findIndex(next => f.id === next.id) === index
        ))
        this.$set(this.warehouseDetail, 'fertilizers', preFertilizers.map(f => {
            // 既に選択済みの肥料は単位をそのままにする
            const baseItem = this.warehouseDetail.fertilizers.find(item => item.id == f.id)
            const newItem = fertilizers.find(item => item.id == f.id)
            const isOtherTenant = filteredExistingFertilizers.some(fx => fx.id === f.id);
            const fertilizer = {
                id: f.id,
                name: f.name,
                unitName: baseItem ? baseItem.unitName : 'kg',
                isEditable: baseItem ? baseItem.isEditable : false,
                isUnitChanged: baseItem ? baseItem.isUnitChanged : false,
                previousUnit: baseItem ? baseItem.unitName : 'kg',
                actualUnit: baseItem ? baseItem.unitName : 'kg',
                tenantId: baseItem ? baseItem.tenantId : undefined,
                isUnitConversionNeeded: baseItem ? baseItem.isUnitChanged : false,
                updateType: baseItem ? (newItem ? baseItem.updateType : 'DELETE') : 'ADD'
            }
            if (isOtherTenant) {
                fertilizer.updateType = baseItem?.updateType ?? undefined;
            }
            return fertilizer
        }))
    }

    // 資材選択モーダル
    openMaterialSelectModal(): void {
        this.initializeMaterials = this.warehouseDetail.expendableMaterials.map(m => {
            return {
                id: m.id,
                name: m.name,
                disabledCheck: this.disabledExpendableMaterialCheck(m)
            }
        })
        this.showMaterialSelectModal = true
    }

    commitMaterial(materials: Material[]): void {
        const concatMaterials = materials.concat(this.warehouseDetail.expendableMaterials.map(m => ({ id: m.id, name: m.name, disabledCheck: false })))
        const preMaterials = concatMaterials.filter((m, index, arr) => (
            arr.findIndex(next => m.id === next.id) === index
        ))
        this.$set(this.warehouseDetail, 'expendableMaterials', preMaterials.map(m => {
            const baseItem = this.warehouseDetail.expendableMaterials.find(item => item.id === m.id)
            const newItem = materials.find(item => item.id === m.id)
            const material = {
                id: m.id,
                name: m.name,
                isEditable: baseItem ? baseItem.isEditable : false,
                updateType: baseItem ? (newItem ? baseItem.updateType : 'DELETE') : 'ADD'
            }
            return material
        }))
    }

    // タブ
    selectTab(tab: 'chemicalOrFertilizer' | 'depreciation' | 'expendable'): void {
        this.selectedTab = tab
    }

    // 購入履歴関連
    openPurchaseHistoryModal(itemType: 'chemicals' | 'fertilizers', itemId: string, unitName: string, itemName: string): void {
        this.itemType = itemType
        this.itemId = itemId
        this.unitName = unitName
        this.itemName = itemName
        this.showPurchaseHistoryModal = true
    }
    savePurchaseHistory(): void {
        this.showPurchaseHistoryModal = false
        this.purchaseHistoryChange = false
    }

    cancelPurchaseHistory(): void {
        if(this.purchaseHistoryChange){
            const result = window.confirm('変更内容を破棄します。よろしいですか。')
            if (result) {
                this.showPurchaseHistoryModal = false
                 this.purchaseHistoryChange = false
            }
        }else{
            this.showPurchaseHistoryModal = false
            this.purchaseHistoryChange = false
        }
    }

    // 減価償却関連
    openDepreciationMaterialAddModal(): void {
        this.showDepreciationMaterialAddModal = true
    }
    addDepreciationMaterial(material: DepreicationAdd | null): void {
        if (material !== null) {
            const newMaterial = {
                materialId: material.material.id,
                name: material.material.name,
                type: material.material.type,
                displayName: material.displayName,
                purchaseDate: material.purchaseDate,
                purchaseAmount: material.purchaseAmount,
                depreciationPeriod: material.depreciationPeriod,
                depreciationTimes: material.depreciationTimes,
                warehouseDepreciationMaterialId : '',
                isEditable: true,
                updateType: 'ADD',
                updated:null
            }
            this.warehouseDetail.depreciationMaterials.push(newMaterial)
            this.showDepreciationMaterialAddModal = false
        }
    }
    cancelDepreciationMaterial(): void {
        this.showDepreciationMaterialAddModal = false
    }
    depreciationTimesPerYear(period: number, times: number): number {
        return Math.round((times / period) * 100) / 100
    }
    depreciationAmountPerTimes(amount: number, times: number): number {
        return Math.round((amount / times) * 100) / 100
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    // 購入履歴関連
    openChemicalBulkInsertModal(itemType: 'chemicals' | 'fertilizers', itemId: string, unitName: string, itemName: string): void {
        this.itemType = itemType
        this.itemId = itemId
        this.unitName = unitName
        this.itemName = itemName
        this.showChemicalBulkInsertModal = true
    }

    created(){
        this.$on('save-success', this.saveChemicalBulkInsertModal);
        this.$on('save-failed', this.handleSaveFailed); 
    }
    saveChemicalBulkInsertModal(): void {
        setTimeout(() => {
            this.changeWarehouseId()
        }, 100);
        this.showChemicalBulkInsertModal = false
    }
    handleSaveFailed(): void {
        this.showChemicalBulkInsertModal = true
    }
    cancelChemicalBulkInsertModal(): void {
        this.showChemicalBulkInsertModal = false
    }
}
